module.exports = __webpack_public_path__ + "static/media/email.b3cb857b.svg";